import { IdCommand } from "commands/IdCommand";
import { NewsletterRegisterCommand } from "commands/NewsletterRegisterCommand";
import { UpdateProfileCommand } from "commands/users/UpdateProfileCommand";
import { UpdateNameCommand } from "commands/users/UpdateNameCommand";
import { UpdateProfileLocationCommand } from "commands/users/UpdateProfileLocationCommand";
import { CodeResult } from "results/CodeResult";
import { GetProfileDefaultsResult } from "results/users/GetProfileDefaultsResult";
import { GetProfileMyAvatarsResult } from "results/users/GetProfileMyAvatarsResult";
import { GetProfileMySchoolResult } from "results/users/GetProfileMySchoolResult";
import { GetProfileReferAFriendResult } from "results/users/GetProfileReferAFriendResult";
import { GetUnlockedAvatarsResult } from "results/users/GetUnlockedAvatarsResult";
import { GetProfileWatchListResult } from "results/users/GetProfileWatchListResult";
import { GetProfileResult } from "results/users/GetProfileResult";
import { NewsletterSubscribedResult } from "results/users/NewsletterSubscribedResult";
import { useApiService } from "services/ApiService";

export const UsersApiService = () => {
    const { get, post } = useApiService({ controller: "/users" });

    return {
        getProfile: () => get<GetProfileResult>("/profile"),
        getNewsletterSubscribed: () => get<NewsletterSubscribedResult>("/newsletter-subscribed"),
        updateProfile: (command: UpdateProfileCommand) => post("/update-profile", command),
        updateName: (command: UpdateNameCommand) => post("/update-name", command),
        updateProfileLocation: (command: UpdateProfileLocationCommand) => post("/update-profile-location", command),
        updateSchoolLevel: (schoolLevelId: number) => post("/update-school-level", { id: schoolLevelId }),
        updateProfileIsFrankenstoriesChecklistCompleted: () =>
            post("/update-profile-frankenstories-checklist-completed"),
        getProfileMyAvatars: () => get<GetProfileMyAvatarsResult>("/avatars"),
        selectProfileAvatar: (avatarId?: number) => post("/select-avatar", { avatarId }),
        getUnlockedAvatars: () => get<GetUnlockedAvatarsResult>("/unlocked-avatars"),
        getReferAFriend: () => get<GetProfileReferAFriendResult>("/refer-a-friend"),
        generateReferrerCode: () => post<CodeResult>("/generate-referrer-code"),
        getMySchool: () => get<GetProfileMySchoolResult>("/school"),
        getDefaults: () => get<GetProfileDefaultsResult>("/defaults"),
        deleteUser: () => post("/delete-user"),
        getProfileWatchList: () => get<GetProfileWatchListResult>("/profile-watch-list"),
        removeUserFromWatchList: (command: IdCommand) => post("/remove-user-from-watch-list", command),
        subscribeToNewsletter: (command: NewsletterRegisterCommand) => post("/newsletter-subscribe", command),
        unsubscribeFromNewsletter: (command: NewsletterRegisterCommand) => post("/newsletter-unsubscribe", command),
    };
};
